export const OFFLINE_DEMO_TIME_ZONE = 'America/Chicago';

export type OfflineDemoAvailabilityReason =
  | 'available'
  | 'globally-disabled'
  | 'production'
  | 'production-like-name'
  | 'production-like-config'
  | 'unsupported-environment'
  | 'contradictory-flags'
  | 'unsupported-site';

export type OfflineDemoAvailability = {
  available: boolean;
  reason: OfflineDemoAvailabilityReason;
};

export type OfflineDemoDatabaseScope = 'primary' | 'offline-demo';

export type OfflineDemoCapability =
  | 'APP_HUB'
  | 'RESTAURANT_POS'
  | 'REPORTS'
  | 'TRANSACTIONS_V4'
  | 'SETTINGS';

export type OfflineDemoRuntime = Readonly<{
  active: boolean;
  databaseScope: OfflineDemoDatabaseScope;
  capabilities: ReadonlySet<OfflineDemoCapability>;
  reset: () => Promise<void>;
  exit: () => void;
}>;
